import angular from "angular";
import { cloneDeep } from "lodash";

angular
    .module('ui-sentinel.alarms')
    .directive('alarmDevices', AlarmDevicesDirective);

function AlarmDevicesDirective() {
    const directive = {
        restrict: 'A',
        controller: ThisDirectiveController,
        controllerAs: 'alarmDevices',
        template: require('./alarm-devices-directive.html'),
        link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
        scope.$watch(
            function (scope) {
                return scope.alarmAdmin.alarm;
            },
            function (newValue, oldValue) {
                controller.alarm = newValue;
            }, true
        );
    }
}

ThisDirectiveController.$inject = ['$q', '$rootScope', '$state', 'AlarmsService', 'DevicesService', 'FeedbackService', 'SentinelUiSession', 'SentryAccountApiService', 'SentinelAccountApiService'];

function ThisDirectiveController($q, $rootScope, $state, AlarmsService, DevicesService, FeedbackService, SentinelUiSession, SentryAccountApiService, SentinelAccountApiService) {
    const vm = {
        alarm: null,
        isOrs: $rootScope.isOrs,
        orsHideButtons: $rootScope.isOrs && !SentinelUiSession.user.isAnAdmin,
        devices: {
            assigned: [],
            available: [],
            removable: []
        },
        sentinels: {
            assigned: [],
            available: [],
            removable: []
        },
        actions: {
            beginAdd: beginAdd,
            endAdd: endAdd,
            add: add,
            beginRemove: beginRemove,
            endRemove: endRemove,
            remove: remove,
            goToDevice: goToDevice,
            reload: load,
            addAll: addAll,
            removeAll: removeAll,
            addSentinel: addSentinel,
            removeSentinel: removeSentinel
        },
        mode: {
            isAdding: null,
            isRemoving: null
        },
        panel: {
            isCollapsed: true,
            toggle: function () {
                this.isCollapsed = !this.isCollapsed;
                if (!this.isCollapsed) {
                    load();
                }
            }
        },
        feedback: FeedbackService,
        hasPermission: {
            toChange: false
        },
        deviceSearchText: null,
        getDevicesByFilter: getDevicesByFilter,
        getSentinelsByFilter: getSentinelsByFilter,
    };
    activate();
    return vm;

    function activate() {
        setPermissions();
    }

    function beginAdd() {
        vm.mode.isAdding = true;
        vm.devices.available = [];
        vm.sentinels.available = [];

        vm.sentinelSearchText = null;
        vm.deviceSearchText = null;

        $rootScope.loading = true;
        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, "").$promise;
        promise.then(
            function (result) {
                const available = [];
                _.forEach(result, function (device) {
                    let isAdded = false;
                    _.forEach(vm.devices.assigned, function (addedDevice) {
                        if (addedDevice.deviceTagId === device.imei) {
                            isAdded = true;
                            return false;
                        }
                    });
                    available.push(angular.extend(device, { isAdded: isAdded }));
                });

                vm.devices.available = available;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );

        const sentinelsPromise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, "").$promise;
        sentinelsPromise.then(
            function (result) {
                const available = [];
                _.forEach(result, function (sentinel) {
                    let isAdded = false;
                    _.forEach(vm.sentinels.assigned, function (addedSentinel) {
                        if (addedSentinel.deviceTagId === sentinel.deviceId) {
                            isAdded = true;
                            return false;
                        }
                    });
                    available.push(angular.extend(sentinel, { isAdded: isAdded }));
                });

                vm.sentinels.available = available;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function getSentinelsByFilter(filter) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        console.log(filter);

        $rootScope.loading = true;
        const promise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                console.log("Sentinels", result);
                const available = [];
                _.forEach(result, function (sentinel) {
                    let isAdded = false;
                    _.forEach(vm.sentinels.assigned, function (addedSentinel) {
                        if (addedSentinel.deviceTagId === sentinel.deviceId) {
                            isAdded = true;
                            return false;
                        }
                    });
                    available.push(angular.extend(sentinel, { isAdded: isAdded }));
                });

                vm.sentinels.available = available;
            }, function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });

    }

    function getDevicesByFilter(filter) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        $rootScope.loading = true;
        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                const available = [];
                _.forEach(result, function (device) {
                    let isAdded = false;
                    _.forEach(vm.devices.assigned, function (addedDevice) {
                        if (addedDevice.deviceTagId === device.imei) {
                            isAdded = true;
                            return false;
                        }
                    });
                    available.push(angular.extend(device, { isAdded: isAdded }));
                });

                vm.devices.available = available;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });

    }

    function endAdd() {
        vm.mode.isAdding = false;
        vm.devices.available = [];
        vm.sentinels.available = [];
    }

    function beginRemove() {
        vm.mode.isRemoving = true;
        vm.devices.removable = [];
        vm.sentinels.removable = [];

        const removable = [];
        _.forEach(vm.devices.assigned, function (device) {
            removable.push(angular.extend(device, { isRemoved: false }));
        });

        const sentinelsRemovable = [];
        _.forEach(vm.sentinels.assigned, function (sentinel) {
            sentinelsRemovable.push(angular.extend(sentinel, { isRemoved: false }));
        });

        vm.devices.removable = removable;
        vm.sentinels.removable = sentinelsRemovable;
    }

    function endRemove() {
        vm.mode.isRemoving = false;
        vm.devices.removable = [];
        vm.sentinels.removable = [];
    }

    function add(device) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.addDevice(vm.alarm, device).$promise;
        promise.then(
            function (result) {
                vm.devices.assigned = result;
                device.isAdded = true;
                device.isRemoved = false;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function addSentinel(sentinel) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.addSentinel(vm.alarm, sentinel).$promise;
        promise.then(
            function (result) {
                vm.sentinels.assigned = result;
                sentinel.isAdded = true;
                sentinel.isRemoved = false;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function addAll() {
        vm.feedback.clear();
        $rootScope.loading = true;
        const promises = [];

        _.forEach(vm.devices.available, function (device) {
            const promise = AlarmsService.addDevice(vm.alarm, device).$promise;
            promise.then(
                function (result) {
                    vm.devices.assigned = result;
                    device.isAdded = true;
                    device.isRemoved = false;
                },
                function (error) {
                    console.log(error);
                    vm.feedback.addErrorFromError(error);
                }
            );
            promises.push(promise);
        });

        _.forEach(vm.sentinels.available, function (sentinel) {
            const promise = AlarmsService.addSentinel(vm.alarm, sentinel).$promise;
            promise.then(
                function (result) {
                    vm.sentinels.assigned = result;
                    sentinel.isAdded = true;
                    sentinel.isRemoved = false;
                },
                function (error) {
                    console.log(error);
                    vm.feedback.addErrorFromError(error);
                }
            );
            promises.push(promise);
        });

        $q.all(promises).then(function () {
            $rootScope.loading = false;
        }).catch(function (e) {
            $rootScope.loading = false;
            console.log(e);
        });

        endAdd();
    }

    function remove(device) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.removeDevice(vm.alarm, device).$promise;
        promise.then(
            function (result) {
                vm.devices.assigned = result;
                device.isRemoved = true;
                device.isAdded = false;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function removeSentinel(sentinel) {
        $rootScope.loading = true;
        vm.feedback.clear();

        const promise = AlarmsService.removeSentinel(vm.alarm, sentinel).$promise;
        promise.then(
            function (result) {
                vm.sentinels.assigned = result;
                sentinel.isRemoved = true;
                sentinel.isAdded = false;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function removeAll() {
        $rootScope.loading = true;
        vm.feedback.clear();
        const promises = [];

        _.forEach(vm.devices.removable, function (device) {
            const promise = AlarmsService.removeDevice(vm.alarm, device).$promise;
            promise.then(
                function (result) {
                    vm.devices.assigned = result;
                    device.isRemoved = true;
                    device.isAdded = false;
                },
                function (error) {
                    console.log(error);
                    vm.feedback.addErrorFromError(error);
                }
            );
            promises.push(promise);
        });

        _.forEach(vm.sentinels.removable, function (sentinel) {
            const promise = AlarmsService.removeSentinel(vm.alarm, sentinel).$promise;
            promise.then(
                function (result) {
                    vm.sentinels.assigned = result;
                    sentinel.isRemoved = true;
                    sentinel.isAdded = false;
                },
                function (error) {
                    console.log(error);
                    vm.feedback.addErrorFromError(error);
                }
            );
            promises.push(promise);
        });

        $q.all(promises).then(function () {
            $rootScope.loading = false;
        }).catch(function (e) {
            $rootScope.loading = false;
            console.log(e);
        });

        endRemove();
    }

    function load() {
        $rootScope.loading = true;
        vm.devices.assigned = [];
        vm.sentinels.assigned = [];

        const promise = AlarmsService.getDevices(SentinelUiSession.focus, vm.alarm).$promise;
        promise.then(
            function (result) {
                vm.devices.assigned = result;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        );

        const sentinelPromise = AlarmsService.getSentinels(SentinelUiSession.focus, vm.alarm).$promise;
        sentinelPromise.then(
            function (result) {
                vm.sentinels.assigned = result;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function setPermissions() {
        if (SentinelUiSession.user.isSystemAdmin ||
            SentinelUiSession.user.isAccountAdmin ||
            SentinelUiSession.user.isAccountEditor) {

            vm.hasPermission.toChange = true;
        }
    }

    function goToDevice(device) {
        const returnState = $state.current.name;
        const returnStateParams = cloneDeep($state.params);
        $state.go('device.admin', {
            deviceTagId: device.deviceTagId,
            referrer: returnState,
            referrerParams: returnStateParams
        });
    }
}
